import { getDisplayedPrice } from '../../../utils/GetDisplayedPrice';
import { DeleteItemFromCart } from '../../../features/cart/DeleteItem';
import UpdateItemQuantity from '../../../features/cart/UpdateItemQuantity';
import { Link } from 'react-router-dom';
import { VariationAttributes } from '../shared/VariationAttributes';
import { getPromo } from '../../../utils/getPromo';
import { optimizeImageUrl } from '../../../utils/optimizeImageUrl';

export const NavBarCartItem = ({ item }) => {
  const price =
    item?.fairAppSalesPrice > 0
      ? item?.fairAppSalesPrice
      : item?.price || item?.fairAppPrice || item?.productPrice;

  const displayedPrice = getDisplayedPrice({
    paymentPlan: item?.paymentPlan || item?.selectedPaymentPlan,
    paymentOptionsBreakdown: item?.paymentOptionsBreakdown,
    flexibleTermOptions: item?.flexibleTermOptions,
    fairAppPrice: price,
    quantity: item?.quantity || 1,
    termMonths: item?.termMonths,
    individualBreakdown: item?.individual_breakdown,
  });
  const category = item?.produtCategory?.parent_category?.slug;
  const sub_category = item?.produtCategory?.slug;
  const promo = getPromo(item);

  return (
    <>
      <li className="grid grid-cols-1 pb-4 lg:px-2">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 xl:w-10 xl:h-10 mb-2">
            <img
              src={item?.vendorBrandImageUrl}
              alt="vendor logo"
              className="w-full h-full object-contain"
            />
          </div>
          <p className="font-duplet text-sm flex">
            <span className="font-semibold pl-2">{item?.venddorBrandName}</span>
          </p>
          {promo && (
            <img
              src={optimizeImageUrl({ url: promo.image, width: 120 })}
              alt={promo.label}
              className="w-8 h-8 rounded-full object-cover mb-2 ml-2"
            />
          )}
        </div>

        <div className="flex space-x-2">
          <div className="w-[40%] h-[100px] p-2 flex justify-center items-center border border-[#DADADA] rounded-[12px]">
            <img
              src={item?.image || item?.coverImage}
              alt={item?.name || item?.productName}
              className="w-[100%] h-full object-cover rounded-[8px]"
            />
          </div>

          <div className="flex flex-col  justify-between w-full">
            <Link
              to={`/${category}/${sub_category}/${item?.productID}/${item?.slug?.replace(/\//g, '')}`}
            >
              <p>{item?.name}</p>
              <VariationAttributes
                variation={item?.selectedVariation}
                className="mt-0.5"
              />
            </Link>

            <div className="flex justify-between items-center w-full">
              <div className="flex space-x-4">
                <div>
                  <div className="text-[#222224] font-medium text-sm flex items-center space-x-2">
                    <UpdateItemQuantity
                      productID={item?.productID}
                      currentQuantity={item?.quantity}
                      selectedVariation={item?.selectedVariation}
                    />
                  </div>
                </div>
                <DeleteItemFromCart
                  productID={item?.productID}
                  selectedVariation={item?.selectedVariation}
                />
              </div>
              <p className="text-[#222224]">{displayedPrice}</p>
            </div>
          </div>
        </div>
      </li>
      <div className="h-[6px] bg-[#F6F6F6] w-full my-2"></div>
    </>
  );
};
